'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggle = toggle;
exports.toggleAll = toggleAll;
exports.checkedAll = checkedAll;
var TOGGLE = exports.TOGGLE = 'list.infinite.check.toggle';
var TOGGLE_ALL = exports.TOGGLE_ALL = 'list.infinite.check.toggleAll';
var CHECKED_ALL = exports.CHECKED_ALL = 'list.infinite.check.checkedAll';

/**
 * Toggle položky.
 * @param area oblast
 * @param id id položky
 */
function toggle(area, id) {
    return {
        type: TOGGLE,
        area: area,
        id: id
    };
}

/**
 * Toggle all položek.
 * @param area oblast
 */
function toggleAll(area) {
    return {
        type: TOGGLE_ALL,
        area: area
    };
}

/**
 * Zaškrtnout vše.
 * @param area oblast
 * @param checked zaškrtnout/odškrtnout
 */
function checkedAll(area) {
    var checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return {
        type: CHECKED_ALL,
        checked: checked,
        area: area
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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